import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import './index.scss';

/**
 * Application Entry Point
 * Following DDD principles - Composition Root pattern
 *
 * Responsibilities:
 * - Bootstrap the application
 * - Mount React to DOM
 * - Minimal logic, maximum composition
 *
 * All application logic, routing, and state management
 * are delegated to the App component and its children.
 */

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
